module.exports = __webpack_public_path__ + "img/t4_cors_nut.prt.3180e7cb.jpg";